"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateUtil = void 0;
class DateUtil {
    constructor() { }
    static fixDateOfBirth(birthDate) {
        const [year, month, day] = birthDate.split("T")[0].split("-");
        return `${month}/${day}/${year}`;
    }
    //ToDo: UTC for now but need discussion on timezone setup for the future
    static fixDateAndTime(dateString) {
        const date = new Date(dateString);
        const formatted = new Intl.DateTimeFormat('en-US', {
            year: '2-digit',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            hour12: true,
            timeZone: 'UTC'
        });
        return formatted.format(date).replace(',', '');
    }
    static checkSearchQueueTableDate(dateString) {
        const parts = dateString.split("/");
        return parts.length === 3;
    }
}
exports.DateUtil = DateUtil;
